import { useParams } from "react-router-dom";
import Case1 from "@/assets/richastory.jpg";

const datas = [
  {
    id: 1,
    title: "Richa’s Story: How Cash Management Changed Her Life",
    img: Case1,
    intro:
      "In the previous issue, we discussed the importance of cash management as the first step in financial planning. Today, we want to bring this concept to life with a real case study—meet Richa, a young professional working for an MNC in Mumbai.",
    problem: {
      description:
        "When Richa approached us, she was living in a shared apartment with two roommates, earning a stable income that comfortably covered her expenses and allowed for some savings. However, after five years of work, she was shocked to find that she had no significant savings, no emergency fund, and no investments. She had no idea where her money had gone, leaving her upset and anxious.",
    },
    discovery: {
      title: "Discovering the Spending Pattern",
      intro:
        "Together, we analysed her finances and uncovered the hidden leaks in her spending:",
      points: [
        "Frequent purchases of expensive clothes and accessories.",
        "Dining out and socializing often.",
        "Regular trips to visit her parents in Pune.",
      ],
      conclusion:
        "While these expenses were understandable, they had added up over time, leaving her without any savings to show for her hard work.",
    },
    turnaround: {
      title: "The Turnaround",
      intro:
        "Once Richa realized her spending pattern, she was determined to take control. Here is what we did together:",
      steps: [
        "Saving First: Richa started setting aside 25% of her income for savings right at the beginning of each month.",
        "Building an Emergency Fund: Within months, she had built a safety net to handle unexpected expenses.",
        "Starting Investments: After achieving her emergency fund goal, she began investing regularly in mutual funds to grow her wealth.",
      ],
    },
    ending: {
      title: "The Happy Ending",
      description:
        "With a clear plan and disciplined approach, Richa did not just regain control of her finances—she achieved something she had not even dreamed of before. She purchased her own flat in Pune, a milestone that brought her immense pride and fulfilment.",
      closing:
        "Today, Richa feels more confident, enjoys her work with less stress, and has a better work-life balance.",
      note: "Her story is proof that small steps in managing your cash can lead to big achievements. If you haven’t started yet, take that first step today—you will thank yourself later!",
      author: "Uma Kumaravelan",
    },
  },
];

export default function CaseStudy() {
  const { id } = useParams<{ id?: string }>();

  if (id === undefined) return <div>Wrong blog ID</div>;

  const blogId = Number(id);
  const caseData = datas.find((b) => b.id === blogId);
  return (
    <>
      <div className="max-w-3xl mx-auto px-4 py-10 font-sans text-gray-800 mt-20">
        <img src={caseData?.img} alt="case" className="w-full h-auto mb-3" />
        <h1 className="text-3xl font-bold mb-6">{caseData?.title}</h1>
        <p className="mb-6">{caseData?.intro}</p>

        <p className="mb-6">{caseData?.problem.description}</p>

        <h2 className="text-2xl font-semibold mt-10 mb-2">
          {caseData?.discovery.title}
        </h2>
        <p className="mb-4">{caseData?.discovery.intro}</p>
        <ul className="list-disc ml-6 mb-4">
          {caseData?.discovery.points.map((point, i) => (
            <li key={i}>{point}</li>
          ))}
        </ul>
        <p className="mb-6">{caseData?.discovery.conclusion}</p>

        <h2 className="text-2xl font-semibold mt-10 mb-2">
          {caseData?.turnaround.title}
        </h2>
        <p className="mb-4">{caseData?.turnaround.intro}</p>
        <ol className="list-decimal ml-6 mb-6">
          {caseData?.turnaround.steps.map((step, i) => <li key={i}>{step}</li>)}
        </ol>

        <h2 className="text-2xl font-semibold mt-10 mb-2">
          {caseData?.ending.title}
        </h2>
        <p className="mb-4">{caseData?.ending.description}</p>
        <p className="mb-4">{caseData?.ending.closing}</p>
        <p className="mb-6 font-semibold italic">{caseData?.ending.note}</p>
        <p className="text-right font-medium">— {caseData?.ending.author}</p>
      </div>
    </>
  );
}
